import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { useAppSelector } from 'shared/lib';
import type { TPreApprovalOfferStepData } from 'shared/types/TRankingService';

import { selectRegistrationAddressFields } from 'entities/creditForm';
import { useSelectDeliverySlotMutation } from 'entities/preApprovals';

import { FormBody } from './FormBody';
import type { TMeetingFormFields } from './types';

type Props = {
  offerData: TPreApprovalOfferStepData;
  onFormSubmit?: () => void;
  onChangeEvent?: (
    offer: TPreApprovalOfferStepData,
    formData: TMeetingFormFields,
    fieldName: keyof TMeetingFormFields,
  ) => void;
  onSubmitEvent?: (offer: TPreApprovalOfferStepData, formData: TMeetingFormFields) => void;
  onShowEvent?: (offer: TPreApprovalOfferStepData) => void;
};

export const DeliveryForm: FC<Props> = (props) => {
  const { offerData, onFormSubmit, onSubmitEvent, onChangeEvent, onShowEvent } = props;
  const { registrationAddress } = useAppSelector(selectRegistrationAddressFields);
  const [selectSlot] = useSelectDeliverySlotMutation();

  const { preApprovalOfferId } = offerData;

  useEffect(() => {
    onShowEvent?.(offerData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const form = useForm<TMeetingFormFields>({
    defaultValues: {
      address: registrationAddress?.value || '',
      dateSlot: undefined,
      timeSlot: undefined,
    },
  });

  const { handleSubmit } = form;

  const onSubmit = async (data: TMeetingFormFields) => {
    const { timeSlot } = data || {};

    await selectSlot({ offerId: preApprovalOfferId || '', slotId: timeSlot || '' });
    onFormSubmit?.();
  };

  return (
    <FormProvider {...form}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormBody
          offerData={offerData}
          onChangeEvent={onChangeEvent}
          onSubmitEvent={onSubmitEvent}
        />
      </form>
    </FormProvider>
  );
};
